import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Table,
  Icon,
  Panel,
  Row,
  Col,
  Checkbox,
  Button,
  ControlLabel,
  Input,
  Message,
} from 'rsuite'
import './styles.less'
import classNames from 'classnames'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import EditButton from '../../components/buttons/editButton/EditButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import AlertWidget from '../confirm/AlertWidget'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import globalMsgUtil from '../../utils/globalMsgUtil'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { sessionGetItemObj, sessionGetItemStr } from '../../utils/sessionHelpers'
import { budgetFormat } from '../../utils/formatterUtil'
import InputForm from '../../components/forms/input/InputForm'

export default function AssetBookingManagementDetailTable({
  schema,
  formSchema,
  loading,
  onReload = () => {},
  onSelect = () => {},
  onViewFiles = () => {},
  onSave = () => {},
  onPreview = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()

  const [tableData, setTableData] = useState([])
  const fs = localStorage.getItem('fontSize')
  const [indeterminate, setIndeterminate] = useState(false)
  const [checkedKeys, setCheckedKeys] = useState([])
  const [countSelected, setCountSelected] = useState(0)
  const [isShowModalHelper, setIsShowModalHelper] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [bodyRequest, setBodyRequest] = useState()
  const [checkedAll, setCheckedAll] = useState(false)
  const [txtConfirmMsg, setConfirmMsg] = useState('')

  const history = useHistory()
  const bookingInfo = sessionGetItemObj('bookingInfo')
  const isViewOnly = !!sessionGetItemStr('isViewOnly')
  const txtConf = 'ยืนยัน'

  useEffect(() => {
    schema?.values?.length > 0 ? setTableData(schema?.values) : setTableData([])
    formSchema?.assetIds?.length > 0 && setCheckedKeys(formSchema.assetIds)
    if (formSchema?.assetIds?.length > 0) {
      setCheckedKeys(formSchema.assetIds)
      setCountSelected(formSchema?.assetIds?.length)
    }
  }, [schema?.values])

  const handleCheckAll = (value, checked) => {
    const keys = checked ? tableData?.map((item) => item.id) : []

    setCheckedAll(checked)
    setIndeterminate(false)
    setCheckedKeys(keys)
    setCountSelected(keys.length)
  }

  const handleCheck = (value, checked) => {
    const keys = checked ? [...checkedKeys, value] : checkedKeys.filter((item) => item !== value)

    if (keys.length === 0) {
      setCheckedAll(false)
    } else if (keys.length > 0 && keys.length < tableData?.length) {
      setIndeterminate(true)
    }

    setCheckedKeys(keys)
    setCountSelected(keys.length)
  }

  const handleCheckRequest = async (data) => {
    // console.log('handleCheckRequest', data)

    if (checkedKeys.length <= 0) {
      setIsShowModalHelper(true)
      return false
    }

    const request = {
      id: bookingInfo.id ? bookingInfo.id : null,
      assetIds: checkedKeys || null,
      reserveProject: data.reserveProject || '',
      note: data.note || '',
      comment: '',
      status: 1,
    }

    setConfirmMsg(`${txtConf}${formSchema.form.button.request}`)

    setBodyRequest(request)
    setIsShowConfirm(true)
    // onSave(request)
  }

  const handleCancelReserve = async (data) => {
    // console.log('formSchema.currentStatus ', formSchema.currentStatus.name)

    const request = {
      id: bookingInfo.id,
      comment: data.comment,
      status: formSchema.currentStatus.name == '2' ? 5 : 4,
    }

    setConfirmMsg(`${txtConf}${formSchema.form.button.cancelReserve}`)

    setBodyRequest(request)
    setIsShowConfirm(true)
  }

  const handleApprove = async (data) => {
    const request = {
      id: bookingInfo.id,
      comment: data.comment,
      status: 3,
    }

    setConfirmMsg(`${txtConf}${formSchema.form.button.approve}`)

    setBodyRequest(request)
    setIsShowConfirm(true)
  }

  const handleReturnEdit = async (data) => {
    const request = {
      id: bookingInfo.id,
      comment: data.comment,
      status: 2,
    }

    setConfirmMsg(`${txtConf}${formSchema.form.button.returnEdit}`)

    setBodyRequest(request)
    setIsShowConfirm(true)
  }

  const handleApproveCancelReserve = async (data) => {
    const request = {
      id: bookingInfo.id,
      note: data.note || '',
      status: 5,
    }

    setConfirmMsg(`${txtConf}${formSchema.form.button.approveCancelReserve}`)

    setBodyRequest(request)
    setIsShowConfirm(true)
  }

  const handleConfSave = async () => {
    const res = await onSave(bodyRequest)

    if (res) {
      setIsShowConfirm(false)
      history.push({
        // pathname: pathname.durableArticles.AssetRequestManagement,
        pathname: pathname.durableArticles.AssetBookingManagement,
      })
    }
  }

  return (
    <>
      {loading && <OverlayLoader />}

      <Panel
        collapsible
        defaultExpanded
        header={'รายการครุภัณฑ์'}
        bordered
        style={{ marginTop: 20 }}
      >
        <div className="table-all-articles">
          <Table
            wordWrap
            // minHeight={400}
            // autoHeight
            height={600}
            loading={loading}
            headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
            data={tableData || []}
            style={{ marginTop: '10px' }}
            affixHeader
          >
            {formSchema?.disabled || formSchema?.isApprover ? (
              <Column width={95} align="center">
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell style={{ padding: 0 }}>
                  {(rowData, index) => {
                    return <>{index + 1}</>
                  }}
                </Cell>
              </Column>
            ) : (
              <Column width={95} align="center">
                <HeaderCell>
                  <Checkbox
                    style={{ marginTop: '-7px', marginLeft: -10 }}
                    inline
                    checked={checkedAll}
                    indeterminate={indeterminate}
                    disabled={isViewOnly}
                    onChange={handleCheckAll}
                  />
                  <b>ลำดับ</b>
                </HeaderCell>
                <Cell style={{ padding: 0 }}>
                  {(rowData, index) => {
                    return (
                      <>
                        <div style={{ marginTop: 10 }}>
                          <Checkbox
                            style={{ marginTop: '-7px', marginLeft: -10 }}
                            value={rowData.id}
                            //disabled={isViewOnly}
                            inline
                            onChange={(value, checked) => handleCheck(value, checked, rowData)}
                            checked={checkedKeys.some((item) => item === rowData.id)}
                          />
                          {index + 1}
                        </div>
                      </>
                    )
                  }}
                </Cell>
              </Column>
            )}

            <Column width={180}>
              <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetCode" />
            </Column>

            <Column minWidth={200} flexGrow={1}>
              <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetName" />
            </Column>

            <Column width={120}>
              <HeaderCell>ราคา/หน่วย</HeaderCell>
              <Cell style={{ textAlign: 'right' }}>
                {(rowData) => {
                  return budgetFormat(rowData.assetAmount)
                }}
              </Cell>
            </Column>

            <Column width={160}>
              <HeaderCell>รุ่น</HeaderCell>
              <Cell dataKey="assetModel" />
            </Column>

            <Column width={160}>
              <HeaderCell>ยี่ห้อ</HeaderCell>
              <Cell dataKey="assetBrand" />
            </Column>

            <Column width={160}>
              <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetType" />
            </Column>

            <Column width={150} align="center">
              <HeaderCell>รูปภาพครุภัณฑ์</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (!rowData.assetImg) {
                    return ''
                  }
                  return (
                    <>
                      <a
                        style={{ cursor: 'pointer', textDecorationLine: 'underline' }}
                        onClick={(_) => {
                          // console.log(rowData)
                          onViewFiles(`${rowData?.assetCode || '__'}`, rowData?.assetImg || null)
                        }}
                      >
                        <Icon icon="file-image-o" style={{ marginRight: '5px' }} />
                        คลิกดูรูปภาพ
                      </a>
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </div>
      </Panel>

      {formSchema?.form?.inputForm && (
        <>
          {formSchema.currentStatus && (
            <Row style={{ marginTop: 30 }}>
              <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                สถานะการขอจอง :
              </Col>
              <Col lg={14} md={14} sm={24} xs={24}>
                {formSchema.currentStatus.label}
              </Col>
              <Col lg={5} md={5} sm={24} xs={24}></Col>
            </Row>
          )}

          {!isViewOnly && !formSchema?.isApprover ? (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel
                    className={classNames(
                      isRequired(formSchema.form.inputForm.reserveProject.validators) && 'required'
                    )}
                  >
                    {formSchema.form.inputForm.reserveProject.label}
                  </ControlLabel>
                </Col>
                <Col lg={14} md={14} sm={24} xs={24}>
                  <InputForm
                    schema={formSchema.form.inputForm.reserveProject}
                    register={register}
                    hideLabel
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={5} md={5} sm={24} xs={24}></Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel
                    className={classNames(
                      isRequired(formSchema.form.inputForm.note.validators) && 'required'
                    )}
                  >
                    {formSchema.form.inputForm.note.label}
                  </ControlLabel>
                </Col>
                <Col lg={14} md={14} sm={24} xs={24}>
                  <InputForm
                    schema={formSchema.form.inputForm.note}
                    register={register}
                    row={3}
                    componentClass="textarea"
                    hideLabel
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={5} md={5} sm={24} xs={24}></Col>
              </Row>
            </>
          ) : (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  {formSchema.form.inputForm.reserveProject.label + ' : '}
                </Col>
                <Col lg={14} md={14} sm={24} xs={24}>
                  {`${formSchema.form.inputForm.reserveProject.value || '-ไม่ระบุ-'}`}
                </Col>
                <Col lg={5} md={5} sm={24} xs={24}></Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  {formSchema.form.inputForm.note.label + ' : '}
                </Col>
                <Col lg={14} md={14} sm={24} xs={24}>
                  {`${formSchema.form.inputForm.note.value || '-ไม่ระบุ-'}`}
                </Col>
                <Col lg={5} md={5} sm={24} xs={24}></Col>
              </Row>
            </>
          )}

          {formSchema?.form?.inputForm.comments?.map((item) => {
            return (
              <Row style={{ marginTop: 10 }}>
                <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <p>{`${item.label} `}</p>
                </Col>
                <Col lg={14} md={14} sm={24} xs={24}>
                  <Message type="info" description={item.value} />
                </Col>
                <Col lg={5} md={5} sm={24} xs={24}></Col>
              </Row>
            )
          })}

          {formSchema.isApprover && formSchema.form.inputForm.comment && (
            <Row style={{ marginTop: 10 }}>
              <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {!isViewOnly ? (
                  <>
                    <ControlLabel
                      className={classNames(
                        isRequired(formSchema.form.inputForm.comment.validators) && 'required'
                      )}
                    >
                      {formSchema.form.inputForm.comment.label}
                    </ControlLabel>
                  </>
                ) : (
                  <>{formSchema.form.inputForm.comment.label + ' : '}</>
                )}
              </Col>
              <Col lg={14} md={14} sm={24} xs={24}>
                {!isViewOnly ? (
                  <>
                    <InputForm
                      schema={formSchema.form.inputForm.comment}
                      register={register}
                      row={3}
                      componentClass="textarea"
                      hideLabel
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </>
                ) : (
                  <>{formSchema.form.inputForm.comment.value || '-ไม่ระบุ-'}</>
                )}
              </Col>
              <Col lg={5} md={5} sm={24} xs={24}></Col>
            </Row>
          )}

          <Row style={{ marginTop: 30 }}>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.form.button.reserveDoc && (
                <Button
                  color="blue"
                  appearance="link" //disabled={loading}
                  disabled={!bookingInfo.id}
                  onClick={() => {
                    onPreview()
                  }}
                >
                  <Icon icon="eye" size="lg" /> {formSchema.form.button.reserveDoc}
                </Button>
              )}

              {!isViewOnly && (
                <>
                  {formSchema.form.button.approve && (
                    <SaveButton
                      disabled={loading}
                      icon="send"
                      children={formSchema.form.button.approve}
                      onClick={handleSubmit(handleApprove)}
                    />
                  )}

                  {formSchema.form.button.approveCancelReserve && (
                    <SaveButton
                      disabled={loading}
                      icon="check-circle"
                      children={formSchema.form.button.approveCancelReserve}
                      onClick={handleSubmit(handleApproveCancelReserve)}
                    />
                  )}

                  {formSchema.form.button.returnEdit && (
                    <EditButton
                      disabled={loading}
                      children={formSchema.form.button.returnEdit}
                      onClick={handleSubmit(handleReturnEdit)}
                    />
                  )}

                  {formSchema.form.button.cancelReserve && (
                    <EditButton
                      disabled={loading}
                      children={formSchema.form.button.cancelReserve}
                      onClick={handleSubmit(handleCancelReserve)}
                    />
                  )}

                  {formSchema.form.button.request && (
                    <SaveButton
                      disabled={loading}
                      icon="send"
                      children={`${formSchema.form.button.request} (${countSelected} รายการ)`}
                      onClick={handleSubmit(handleCheckRequest)}
                    />
                  )}
                </>
              )}

              {formSchema.form.button.cancel && (
                <CancelButton
                  children={formSchema.form.button.cancel}
                  onClick={(_) => {
                    history.push({
                      pathname: formSchema.isApprover
                        ? pathname.durableArticles.AssetBookingManagementOfficer
                        : pathname.durableArticles.AssetBookingManagement,
                    })
                  }}
                />
              )}
            </Col>
          </Row>
        </>
      )}

      <AlertWidget
        title={globalMsgUtil.WARN_SELECTED_ITEM_TITLE}
        show={isShowModalHelper}
        detail={globalMsgUtil.WARN_SELECTED_ITEM_DETAIL}
        onClose={() => {
          setIsShowModalHelper(false)
        }}
      />

      <ConfirmWidget
        //title={globalMsgUtil.CONFIRM_SAVE_TITLE}
        title={txtConfirmMsg}
        show={isShowConfirm}
        detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleConfSave}
      />
    </>
  )
}
